import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Fab, GlobalActions } from '@michelin/acid-components';
import {
  ArrowBack,
  Edit,
  Save,
  Timelapse,
} from '@material-ui/icons';
import usePermissionsSPP from 'hooks/usePermissionsSPP';

interface GenericActionButtonsProps {
  validateAction: string,
  preventEdition?: boolean,
  readOnly: boolean,
  isSaving: boolean,
  isDirty: boolean,
  additionalEditButtons?: React.ReactNodeArray;
  onSave: ()=>void,
}

export function GenericActionButtons({
  additionalEditButtons, validateAction, readOnly, isSaving, isDirty, onSave, preventEdition,
}:GenericActionButtonsProps) {
  const permissions = usePermissionsSPP();
  const history = useHistory();
  const { t } = useTranslation();

  if (!permissions.allowsAction(validateAction) || preventEdition) {
    if (!readOnly) history.push('view');
    return null;
  }

  return (
    <GlobalActions>
      {!readOnly || preventEdition ? additionalEditButtons : null }
      <Fab
        color="primary"
        aria-label={t('Edit')}
        onClick={() => history.push('edit')}
        disabled={!readOnly || preventEdition}
      >
        <Edit />
      </Fab>
      <Fab
        color="inherit"
        aria-label={t('Saving')}
        disabled
        displayDisabled={isSaving}
      >
        <Timelapse />
      </Fab>
      <Fab
        color={isDirty ? 'primary' : 'inherit'}
        aria-label={t('Save')}
        onClick={onSave}
        disabled={isSaving || readOnly}
      >
        <Save />
      </Fab>
      <Fab
        color="primary"
        aria-label={t('Back')}
        onClick={() => {
          history.push('view');
        }}
        disabled={isSaving || readOnly}
        displayDisabled={!readOnly}
      >
        <ArrowBack />
      </Fab>
    </GlobalActions>
  );
}
